import { applicationsClassification } from './applicationsClassification';
import { count } from './count';
import { countFilteredApplications } from './countFilteredApplications';
import { groupApplicationsBySubcategory } from './groupApplicationsBySubcategory';
import { groupDaily } from './groupDaily';
import { groupUsersFromTenantApps } from './groupUsersFromTenantApps';
import { groupWeekly } from './groupWeekly';
import { sortByUserCount } from './sortByUserCount';

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- generic type
export const transformers: Record<string, (data: any) => any> = {
    applicationsClassification,
    count,
    countFilteredApplications,
    groupApplicationsBySubcategory,
    groupDaily,
    groupUsersFromTenantApps,
    groupWeekly,
    sortByUserCount
};
